import { Action } from "@reduxjs/toolkit";
import { values } from "lodash";
import { put, call } from "redux-saga/effects";
import { GenericUpdateActionPayload } from "../../interfaces/action";
import HttpClient from "../../utils/HttpClient";
import { ApiRequest, ApiRequestFailure, ApiRequestSuccess, GenericUpdate } from "../actions";

const client = new HttpClient();

interface ApiRequestPossibleActions {
  success?: Action,
  successGenericUpdate?: GenericUpdateActionPayload<any>,
  failure?: Action,
  failureGenericUpdate?: GenericUpdateActionPayload<any>,
  before?: Action,
  beforeGenericUpdate?: GenericUpdateActionPayload<any>,
  after?: Action,
  afterGenericUpdate?: GenericUpdateActionPayload<any>,
}


export function* genericApiHandler(type: "POST" | "GET", url : string, data: any, actions: ApiRequestPossibleActions) {
  yield put(ApiRequest())
  
  //Before actions
  if(actions.before) {
    //@ts-ignore
    yield put(actions.before())
  }
  if(actions.beforeGenericUpdate) {
    yield put(GenericUpdate(actions.beforeGenericUpdate))
  }

  try {
    let response;
    if(type === "POST") {
      //@ts-ignore
      response = yield call(() => {return client.post(url, data)}) as HttpResponse<any>
    }
    else {
      //@ts-ignore
      response = yield call(() => {return client.get(url, data)}) as HttpResponse<any>
    }

    if(response.status === 200 || response.status === 201) {
      yield put(ApiRequestSuccess())
      //Success Actions
      if(actions.success) {
        //@ts-ignore
        yield put(actions.success)
      }
      if(actions.successGenericUpdate) {
        if(actions.successGenericUpdate.field === 'session_data') {
          localStorage.setItem('jwt', response.data.token);
          console.log("SET")
        }
        yield put(GenericUpdate({
          ...actions.successGenericUpdate,
          values: response.data
        }))
      }
    } 
    else {
      throw (response.status)
    }
  }
  
  catch(e) {
    console.log(e)
    yield put(ApiRequestFailure())
    //Failure Actions
    if(actions.failure) {
      //@ts-ignore
      yield put(actions.failure())
    }
    if(actions.failureGenericUpdate) {
      yield put(GenericUpdate(actions.failureGenericUpdate))
    }
  }

  //After Actions
  if(actions.after) {
    //@ts-ignore
    yield put(actions.after())
  }  
  if(actions.afterGenericUpdate) {
    yield put(GenericUpdate(actions.afterGenericUpdate))
  }
}